import { usePagination } from '@mantine/hooks';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';

const PAGE_SIZE = 20;
const PAGE_PARAM = 'page';
const pageSchema = z.coerce.number().int().positive().catch(1);

export function usePanelPaginationParams(totalItems: number) {
  const [searchParams, setSearchParams] = useSearchParams();
  const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
  const requestedPage = pageSchema.parse(searchParams.get(PAGE_PARAM));
  const currentPage = Math.min(requestedPage, totalPages);

  const setPageParam = (page: number) => {
    setSearchParams((prev) => {
      if (page === 1) {
        prev.delete(PAGE_PARAM);
      } else {
        prev.set(PAGE_PARAM, String(page));
      }
      return prev;
    });
  };

  const { setPage, active } = usePagination({
    total: totalPages,
    page: currentPage,
    onChange: setPageParam,
  });
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const endIndex = Math.min(startIndex + PAGE_SIZE, totalItems);

  return {
    currentPage: active,
    endIndex,
    setPage,
    startIndex,
    totalItems,
    totalPages,
  };
}
